import { useTranslations } from 'next-intl';
import { memo, type ReactNode } from 'react';
import { BaseLineDuration } from '@/app/components/icons/BaseLineDuration';
import { ProductLineReviewing } from '@/app/components/icons/ProductLineReviewing';
import type { Activity } from '@/app/types';
import { cn } from '@/app/utils';

interface ActivityStatusProps {
  status: Activity['phase'];
  className?: string;
}

type ActivityPhase = Exclude<Activity['phase'], undefined>;

const getStatusIcon = (status: ActivityPhase): ReactNode => {
  switch (status) {
    case 'awarded':
    case 'completed':
      return <ProductLineReviewing className="text-sm" />;
    default:
      return <BaseLineDuration className="text-sm" />;
  }
};

export const ActivityStatus = memo(function ActivityStatus({ status, className }: ActivityStatusProps) {
  const t = useTranslations();

  if (!status || status === 'unspecified') return null;

  return (
    <div
      className={cn(
        'inline-flex h-6 flex-shrink-0 items-center justify-center gap-1 rounded bg-white/[.10] px-2 py-0 text-system-white64 text-xs',
        className,
      )}
    >
      {getStatusIcon(status)}
      <span className="leading-[140%]">{t(`activity.status.${status}`)}</span>
    </div>
  );
});
